import { createBrowserRouter, Navigate } from 'react-router-dom';

import { STATIC_MODE } from '../api/client';
import AppShell from '../components/AppShell';
import MeccsekPage from '../pages/MeccsekPage';
import NapokPage from '../pages/NapokPage';
import PontokPage from '../pages/PontokPage';
import SzabalyokPage from '../pages/SzabalyokPage';
import KontaktokPage from '../pages/KontaktokPage';
import IdojarasPage from '../pages/IdojarasPage';
import KepekPage from '../pages/KepekPage';
import KerdoivPage from '../pages/KerdoivPage';
import RanglistaPage from '../pages/RanglistaPage';
import StatisztikaPage from '../pages/StatisztikaPage';
import ParositasokPage from '../pages/ParositasokPage';
import KonzultacioPage from '../pages/KonzultacioPage';
import JatekosmenedzsmentPage from '../pages/JatekosmenedzsmentPage';
import AdminPage from '../pages/AdminPage';
import NotFoundPage from '../pages/NotFoundPage';

// Full route table — the live site (backend on).
const fullChildren = [
  // Post-tournament landing: the root renders the Konzultáció article.
  // Meccsek is still reachable at /meccsek (just no longer the landing page).
  { index: true, element: <KonzultacioPage /> },
  { path: 'meccsek', element: <MeccsekPage /> },
  // Every day's matches on one page (navbar: "2026").
  { path: 'napok', element: <NapokPage /> },
  { path: 'pontok', element: <PontokPage /> },
  { path: 'szabalyok', element: <SzabalyokPage /> },
  { path: 'kontaktok', element: <KontaktokPage /> },
  { path: 'ido', element: <IdojarasPage /> },
  { path: 'kepek', element: <KepekPage /> },
  { path: 'kerdoiv', element: <KerdoivPage /> },
  { path: 'ranglista', element: <RanglistaPage /> },
  // URL-only for now (like /ranglista): linked from nowhere until revealed.
  { path: 'statisztika', element: <StatisztikaPage /> },
  { path: 'parositasok', element: <ParositasokPage /> },
  // The consultation article (ported from the old standalone umag.html page).
  { path: 'konzultacio', element: <KonzultacioPage /> },
  { path: 'jatekosmenedzsment', element: <JatekosmenedzsmentPage /> },
  { path: 'admin', element: <AdminPage /> },
];

// STATIC / HIBERNATION MODE (VITE_STATIC=1): only the two backend-free pages
// resolve — the Konzultáció article and /napok (which reads a bundled JSON,
// see useMatches). Everything else redirects home so no page tries to reach the
// switched-off API. Reverse by unsetting VITE_STATIC (see STATIC_MODE).
const staticChildren = [
  { index: true, element: <KonzultacioPage /> },
  { path: 'konzultacio', element: <KonzultacioPage /> },
  { path: 'napok', element: <NapokPage /> },
  { path: '*', element: <Navigate to="/" replace /> },
];

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: STATIC_MODE ? staticChildren : fullChildren,
  },
  // 404 is layout-less (full-bleed photo), mirroring the Blazor NoLayout NotFoundPage.
  // In static mode there is no 404 — unknown paths fall through to the redirect above.
  { path: '*', element: STATIC_MODE ? <Navigate to="/" replace /> : <NotFoundPage /> },
]);
